import { TileCornerBuildingType } from '@colonist/game-states';
import { MechanicValidator } from './MechanicValidator.ts';
export class MechanicValidatorBarbarianInvasion extends MechanicValidator {
    getBarbarianStrength() {
        let barbarianStrength = 0;
        for (const tileCorner of this.mapValidator.tileState.tileCorners){
            if (tileCorner.owner === undefined) continue;
            if (tileCorner.buildingType !== TileCornerBuildingType.City) continue;
            barbarianStrength += 1;
        }
        return barbarianStrength;
    }
    getBarbarianProgress() {
        return this.barbarianInvasionState.barbarianProgress;
    }
    constructor(playerValidators, mapValidator, barbarianInvasionState){
        super(playerValidators, mapValidator);
        this.barbarianInvasionState = barbarianInvasionState;
    }
}
